import React, { useState } from "react";
import { Button, Input, message, Modal, Spin, Table } from "antd";
import { ModalProps } from "antd/lib/modal";
import style from "./index.module.scss";
import { findCourseList } from "service/score";
import { TableRowSelection } from "antd/lib/table/interface";
import { copyRules, CourseListItem } from "service/score";
import { errorMessage } from "service/service";
import { ResultMessage } from "components/ResultMessage";
import useRequestFn from "utils/useRequestFn";

interface CourseListModalProps extends ModalProps {
    onCancel: () => void;
    ruleId?: number; //要复制的规则id
}

export default function CourseListModal({
    onCancel,
    ruleId,
    ...resProps
}: CourseListModalProps) {
    const { Search } = Input;
    const [getDataAction, { loading }] = useRequestFn(findCourseList);
    const [copy, { data, loading: copyLoading }] = useRequestFn(copyRules);

    const [selectedRowKeys, setSelectedRowKeys] = useState<string[] | number[]>(
        []
    ); //当前多选选中项(显示)

    const columns = [
        {
            title: "课程编号",
            dataIndex: "courseno"
        },
        {
            title: "课程序号",
            dataIndex: "courseseq"
        },
        {
            title: "课程名称",
            dataIndex: "coursename"
        }
    ];

    const onOk = async () => {
        if (!ruleId) return;

        try {
            await copy(selectedRowKeys, ruleId + "");
            message.success("复制成功");
            onCancel();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    const rowSelection: TableRowSelection<CourseListItem> = {
        onChange: selectedRowKeys => {
            setSelectedRowKeys(selectedRowKeys);
        }
    };

    const [list, setList] = useState<CourseListItem[]>([]);
    async function search(text: string) {
        try {
            const res = await getDataAction(text);
            setList(res);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const footer = (
        <div>
            <Button key="back" onClick={() => onCancel()}>
                取消
            </Button>
            <Button
                key="submit"
                type="primary"
                onClick={onOk}
                loading={copyLoading}
                disabled={selectedRowKeys.length === 0}>
                确认
            </Button>
        </div>
    );

    return (
        <Modal
            width={800}
            centered
            title="应用到其他课程"
            maskClosable={false}
            className={style.root}
            footer={footer}
            onCancel={onCancel}
            {...resProps}>
            <div className={style.tips}>
                注意：
                选择课程后并确认后，在本课程中设置好的成绩规则将被复制到所选课程中，如需调整，请前往对应课程的成绩规则中修改并保存。
            </div>
            <div className={style.btn}>
                <Search
                    placeholder="请输入课程名称、编号或序号"
                    onSearch={value => search(value)}
                    className={style.search}
                />
            </div>

            <Spin spinning={loading}>
                <Table
                    rowKey="id"
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={list || []}
                    pagination={false}
                    scroll={{ y: 280 }}
                />
            </Spin>
        </Modal>
    );
}
